// extracted by mini-css-extract-plugin
export var modal = "_u7-0";
export var table = "_u7-1";